import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { PageHeader } from './PageHeader';
import styles from './PageShell.module.css';

interface PageShellProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const PageShell = ({ title, description, actions, children, className }: PageShellProps) => (
  <section className={clsx(styles.page, className)}>
    <PageHeader title={title} description={description} right={actions} />
    {children}
  </section>
);
